"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SelectDialogField: true
};
exports.default = exports.SelectDialogField = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _SelectField = require("../FormField/_SelectField");
var _isEnterOrSpace = require("../utils/isEnterOrSpace");
var _Button = require("../Buttons/Button");
var _Dialog = require("../Dialog/Dialog");
var _Icon = require("../Icon/Icon");
var _IconButton = require("../IconButton/IconButton");
var _Toolbar = require("../Toolbar/Toolbar");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _useUpdatesOnlyEffect = require("../utils/useUpdatesOnlyEffect");
var _isFunction = require("../utils/isFunction");
var _SelectDialogContext = require("./_SelectDialogContext");
var _SelectDialogField = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SelectDialogField.css") : void 0);
var _SelectDialogField2 = require("./SelectDialogField.types");
Object.keys(_SelectDialogField2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SelectDialogField2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SelectDialogField2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-select-dialog-field';
const DEFAULT_VIEW = 'selectView';
/**
 * The **SelectDialogField** enables users to select one or more items
 * from a list or table using a Dialog component.
 * It is essentially an input field that
 *
 * * displays the selected value(s)
 * * allows for selected value(s) to be cleared
 * * opens the selection dialog.
 */
const SelectDialogField = exports.SelectDialogField = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  const {
      clearFieldAriaLabel,
      controlProps,
      dialogTriggerAriaLabel,
      dialogTriggerButtonProps,
      dialogTriggerIconProps,
      clearFieldProps,
      clearFieldIconProps,
      currentView = 'selectView',
      decorators = {},
      dialogProps,
      onClearField,
      onClose,
      onOpen,
      value,
      placeholder,
      showDialog,
      additionalViews,
      bodyHeight = '500px',
      selectView,
      detailView,
      addNewView,
      onViewChange,
      readOnly,
      disabled,
      validationMessage,
      backButtonProps,
      goToAddNewViewButtonProps,
      dataRendering
    } = props,
    otherProps = __rest(props, ["clearFieldAriaLabel", "controlProps", "dialogTriggerAriaLabel", "dialogTriggerButtonProps", "dialogTriggerIconProps", "clearFieldProps", "clearFieldIconProps", "currentView", "decorators", "dialogProps", "onClearField", "onClose", "onOpen", "value", "placeholder", "showDialog", "additionalViews", "bodyHeight", "selectView", "detailView", "addNewView", "onViewChange", "readOnly", "disabled", "validationMessage", "backButtonProps", "goToAddNewViewButtonProps", "dataRendering"]);
  const [currentViewKey, setCurrentView] = (0, _react.useState)(currentView);
  const [showSelectDialog, setShowSelectDialog] = (0, _react.useState)(showDialog);
  const [showClearField, setShowClearField] = (0, _react.useState)(!!value);
  const firstFocusDefaultRef = (0, _react.useRef)(null);
  const backButtonDefaultRef = (0, _react.useRef)(null);
  const classnames = _bind.default.bind(_SelectDialogField.default);
  const internalComboboxRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    setShowClearField(!!value);
  }, [value]);
  (0, _react.useEffect)(() => {
    var _a;
    setCurrentView(((_a = currentView === null || currentView === void 0 ? void 0 : currentView.trim()) === null || _a === void 0 ? void 0 : _a.length) ? currentView : DEFAULT_VIEW);
  }, [currentView]);
  (0, _react.useEffect)(() => {
    onViewChange === null || onViewChange === void 0 ? void 0 : onViewChange(currentViewKey);
  }, [currentViewKey]);
  (0, _react.useEffect)(() => {
    setShowSelectDialog(showDialog);
  }, [showDialog]);
  (0, _useUpdatesOnlyEffect.useUpdatesOnlyEffect)(() => {
    var _a, _b;
    if (!showSelectDialog) {
      onClose === null || onClose === void 0 ? void 0 : onClose();
      (_b = (_a = internalComboboxRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
  }, [showSelectDialog]);
  const handleOnClick = event => {
    if (!readOnly && !disabled) {
      setShowSelectDialog(true);
      onOpen === null || onOpen === void 0 ? void 0 : onOpen(event);
    }
  };
  const handleClearOnClick = event => {
    var _a, _b;
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    (_b = (_a = internalComboboxRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    onClearField === null || onClearField === void 0 ? void 0 : onClearField(event);
  };
  const handleOnClearKeyDown = event => {
    if ((0, _isEnterOrSpace.isEnterOrSpace)(event)) {
      handleClearOnClick(event);
      event.preventDefault();
    }
  };
  const passChildProps = (child, childProps) => {
    if (child.displayName === 'SelectionFilter') {
      return {
        inputRef: (0, _reactMergeRefs.default)([childProps === null || childProps === void 0 ? void 0 : childProps.inputRef, firstFocusDefaultRef])
      };
    }
    return null;
  };
  const goToAddNewViewButton = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({
    type: "link"
  }, goToAddNewViewButtonProps, {
    onClick: (0, _chainFunction.default)(() => setCurrentView('addNewView'), goToAddNewViewButtonProps === null || goToAddNewViewButtonProps === void 0 ? void 0 : goToAddNewViewButtonProps.onClick)
  }), addNewView === null || addNewView === void 0 ? void 0 : addNewView.buttonLabel, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    iconName: "arrow-3-e"
  }));
  const addNewItemViewConfirmButton = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({}, addNewView === null || addNewView === void 0 ? void 0 : addNewView.confirmProps, {
    onClick: (0, _chainFunction.default)(() => setCurrentView(DEFAULT_VIEW), addNewView === null || addNewView === void 0 ? void 0 : addNewView.onConfirm, (_a = addNewView === null || addNewView === void 0 ? void 0 : addNewView.confirmProps) === null || _a === void 0 ? void 0 : _a.onClick)
  }), addNewView === null || addNewView === void 0 ? void 0 : addNewView.confirmLabel);
  const detailViewConfirmButton = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({}, detailView === null || detailView === void 0 ? void 0 : detailView.confirmProps, {
    onClick: (0, _chainFunction.default)(detailView === null || detailView === void 0 ? void 0 : detailView.onConfirm, () => setCurrentView(DEFAULT_VIEW))
  }), detailView === null || detailView === void 0 ? void 0 : detailView.confirmLabel);
  const cancelButton = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({
    type: "link"
  }, selectView === null || selectView === void 0 ? void 0 : selectView.cancelProps, {
    onClick: (0, _chainFunction.default)(() => setShowSelectDialog(false), (_b = selectView === null || selectView === void 0 ? void 0 : selectView.cancelProps) === null || _b === void 0 ? void 0 : _b.onClick)
  }), selectView === null || selectView === void 0 ? void 0 : selectView.cancelLabel);
  const footerClearButton = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({
    type: "link"
  }, selectView === null || selectView === void 0 ? void 0 : selectView.footerClearProps, {
    onClick: (0, _chainFunction.default)(event => {
      setShowSelectDialog(false);
      event === null || event === void 0 ? void 0 : event.stopPropagation();
    }, onClearField, (_c = selectView === null || selectView === void 0 ? void 0 : selectView.footerClearProps) === null || _c === void 0 ? void 0 : _c.onClick)
  }), selectView === null || selectView === void 0 ? void 0 : selectView.footerClearLabel);
  const backToDefaultViewButton = (backButtonProps === null || backButtonProps === void 0 ? void 0 : backButtonProps.ariaLabel) ? (/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({}, backButtonProps, {
    ref: (0, _reactMergeRefs.default)([backButtonDefaultRef, (_d = backButtonProps === null || backButtonProps === void 0 ? void 0 : backButtonProps.ref) !== null && _d !== void 0 ? _d : null]),
    iconName: "arrow-2-w",
    iconProps: Object.assign({
      forceSize: 'xs-plus'
    }, backButtonProps === null || backButtonProps === void 0 ? void 0 : backButtonProps.iconProps),
    onClick: (0, _chainFunction.default)(() => setCurrentView(DEFAULT_VIEW), backButtonProps === null || backButtonProps === void 0 ? void 0 : backButtonProps.onClick)
  }))) : null;
  const selectViewConfirmButton = /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({}, selectView === null || selectView === void 0 ? void 0 : selectView.confirmProps, {
    className: classnames(`${CSS_BLOCK}__select-view-confirm`, (_e = selectView === null || selectView === void 0 ? void 0 : selectView.confirmProps) === null || _e === void 0 ? void 0 : _e.className),
    onClick: (0, _chainFunction.default)(selectView === null || selectView === void 0 ? void 0 : selectView.onConfirm, (_f = selectView === null || selectView === void 0 ? void 0 : selectView.confirmProps) === null || _f === void 0 ? void 0 : _f.onClick)
  }), selectView === null || selectView === void 0 ? void 0 : selectView.confirmLabel);
  const footerToolbarClasses = classnames(`${CSS_BLOCK}__footer-toolbar`);
  const views = (0, _react.useMemo)(() => Object.assign(Object.assign({}, additionalViews), {
    selectView: Object.assign(Object.assign({}, selectView), {
      headerProps: Object.assign({}, selectView === null || selectView === void 0 ? void 0 : selectView.headerProps),
      footerAriaLabel: selectView === null || selectView === void 0 ? void 0 : selectView.footerAriaLabel,
      footer: (/*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar, {
        toolbarStyle: "transparent",
        className: footerToolbarClasses,
        navigationType: "tabKeyOnly",
        ariaLabel: selectView === null || selectView === void 0 ? void 0 : selectView.footerAriaLabel
      }, (addNewView === null || addNewView === void 0 ? void 0 : addNewView.body) && /*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar.Start, null, goToAddNewViewButton), /*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar.End, null, (selectView === null || selectView === void 0 ? void 0 : selectView.showFooterClear) ? footerClearButton : undefined, selectView === null || selectView === void 0 ? void 0 : selectView.footer, (selectView === null || selectView === void 0 ? void 0 : selectView.isMultiSelect) ? selectViewConfirmButton : null, cancelButton)))
    }),
    detailView: Object.assign(Object.assign({}, detailView), {
      titleIcon: backToDefaultViewButton,
      headerProps: Object.assign({}, detailView === null || detailView === void 0 ? void 0 : detailView.headerProps),
      footerAriaLabel: detailView === null || detailView === void 0 ? void 0 : detailView.footerAriaLabel,
      footer: detailView ? (/*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar, {
        toolbarStyle: "transparent",
        className: footerToolbarClasses,
        navigationType: "tabKeyOnly",
        ariaLabel: detailView.footerAriaLabel
      }, /*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar.End, null, detailView.footer, detailViewConfirmButton))) : null
    }),
    addNewView: Object.assign(Object.assign({}, addNewView), {
      titleIcon: backToDefaultViewButton,
      headerProps: Object.assign({}, addNewView === null || addNewView === void 0 ? void 0 : addNewView.headerProps),
      footerAriaLabel: addNewView === null || addNewView === void 0 ? void 0 : addNewView.footerAriaLabel,
      footer: addNewView ? (/*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar, {
        toolbarStyle: "transparent",
        className: footerToolbarClasses,
        navigationType: "tabKeyOnly",
        ariaLabel: addNewView.footerAriaLabel
      }, /*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar.End, null, addNewView.footer, addNewItemViewConfirmButton))) : null
    })
  }), [selectView, detailView, addNewView, additionalViews, cancelButton, bodyHeight]);
  const view = views && views[currentViewKey] || null;
  const dialogId = (0, _useUniqueId.default)();
  let controlAriaProps = {};
  if (!disabled && !readOnly) {
    controlAriaProps = {
      role: 'combobox',
      'aria-haspopup': 'dialog',
      'aria-expanded': !!showSelectDialog,
      'aria-controls': showSelectDialog ? dialogId : null,
      'aria-required': otherProps === null || otherProps === void 0 ? void 0 : otherProps.required,
      tabIndex: 0 // make combobox focusable
      // for JAWS to be able to detect the field in forms mode
    };
  }
  const selectDialogContextValue = (0, _react.useMemo)(() => ({
    validationMessage,
    showSelectDialog
  }), [validationMessage, showSelectDialog]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SelectField.SelectField, Object.assign({}, otherProps, {
    controlProps: Object.assign(Object.assign(Object.assign({}, controlProps), controlAriaProps), {
      onKeyDown: (0, _chainFunction.default)(event => {
        if ((0, _isEnterOrSpace.isEnterOrSpace)(event) || (0, _keycode.default)(event) === 'down') {
          handleOnClick(event);
          event.preventDefault();
        }
      }, controlProps === null || controlProps === void 0 ? void 0 : controlProps.onKeyDown)
    }),
    controlRef: (0, _reactMergeRefs.default)([(_g = otherProps === null || otherProps === void 0 ? void 0 : otherProps.controlRef) !== null && _g !== void 0 ? _g : null, internalComboboxRef]),
    onClick: (0, _chainFunction.default)(handleOnClick, controlProps === null || controlProps === void 0 ? void 0 : controlProps.onClick),
    value: value,
    isRenderedValue: (0, _isFunction.isFunction)(dataRendering === null || dataRendering === void 0 ? void 0 : dataRendering.inputRenderer) || typeof value !== 'string' && typeof value !== 'number',
    ref: ref,
    disabled: disabled,
    readOnly: readOnly,
    decorators: Object.assign(Object.assign({}, decorators), {
      inputEnd: [..._react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.inputEnd), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({}, dialogTriggerButtonProps, {
        ariaLabel: dialogTriggerAriaLabel,
        "data-test": "triggerButton",
        className: classnames(dialogTriggerButtonProps === null || dialogTriggerButtonProps === void 0 ? void 0 : dialogTriggerButtonProps.className, `${CSS_BLOCK}__dialog-trigger-btn`),
        iconName: "window-restore",
        iconProps: Object.assign(Object.assign({}, dialogTriggerButtonProps === null || dialogTriggerButtonProps === void 0 ? void 0 : dialogTriggerButtonProps.iconProps), dialogTriggerIconProps),
        innerProps: {
          className: classnames((_h = dialogTriggerButtonProps === null || dialogTriggerButtonProps === void 0 ? void 0 : dialogTriggerButtonProps.innerProps) === null || _h === void 0 ? void 0 : _h.className, `${CSS_BLOCK}__dialog-trigger-btn-inner`, `${CSS_BLOCK}__dialog-trigger-btn-inner-specific`)
        },
        onClick: (0, _chainFunction.default)(handleOnClick, dialogTriggerButtonProps === null || dialogTriggerButtonProps === void 0 ? void 0 : dialogTriggerButtonProps.onClick),
        onKeyDown: (0, _chainFunction.default)(event => {
          if ((0, _isEnterOrSpace.isEnterOrSpace)(event)) {
            handleOnClick(event);
            event.preventDefault();
          }
        }, dialogTriggerButtonProps === null || dialogTriggerButtonProps === void 0 ? void 0 : dialogTriggerButtonProps.onKeyDown)
      }))],
      afterInput: [...(showClearField && !readOnly && !disabled ? [/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({}, clearFieldProps, {
        ariaLabel: clearFieldAriaLabel,
        onClick: (0, _chainFunction.default)(handleClearOnClick, clearFieldProps === null || clearFieldProps === void 0 ? void 0 : clearFieldProps.onClick),
        onKeyDown: (0, _chainFunction.default)(handleOnClearKeyDown, clearFieldProps === null || clearFieldProps === void 0 ? void 0 : clearFieldProps.onKeyDown),
        iconProps: Object.assign(Object.assign(Object.assign({}, clearFieldProps === null || clearFieldProps === void 0 ? void 0 : clearFieldProps.iconProps), clearFieldIconProps), {
          size: 'xs'
        }),
        iconName: "close"
      }))] : []), ..._react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.afterInput)]
    }),
    placeholder: placeholder,
    validationMessage: validationMessage
  })), view !== null && (/*#__PURE__*/_react.default.createElement(_SelectDialogContext.SelectDialogContext.Provider, {
    value: selectDialogContextValue
  }, /*#__PURE__*/_react.default.createElement(_Dialog.Dialog, Object.assign({}, dialogProps, {
    firstFocusRef: currentViewKey === 'selectView' ? firstFocusDefaultRef : backButtonDefaultRef,
    "aria-modal": true,
    id: dialogId,
    titleIcon: view.titleIcon,
    title: view.title,
    titleProps: view === null || view === void 0 ? void 0 : view.titleProps,
    titleContainerProps: Object.assign(Object.assign({}, dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.titleContainerProps), {
      className: classnames((_j = dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.titleContainerProps) === null || _j === void 0 ? void 0 : _j.className, `${CSS_BLOCK}__title-container`)
    }),
    headerProps: view === null || view === void 0 ? void 0 : view.headerProps,
    show: showSelectDialog,
    onHide: (0, _chainFunction.default)(() => setShowSelectDialog(false), dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.onHide),
    className: classnames(dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.className, `${CSS_BLOCK}__select-dialog`),
    bodyProps: view === null || view === void 0 ? void 0 : view.bodyProps,
    dimensions: Object.assign({
      minHeight: bodyHeight
    }, dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.dimensions),
    footer: (view === null || view === void 0 ? void 0 : view.footer) ? Object.assign(Object.assign({}, view.footerProps), {
      ariaLabel: view.footerAriaLabel,
      mainContent: view.footer
    }) : {}
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, view.body)))));
});
SelectDialogField.displayName = 'SelectDialogField';
var _default = exports.default = SelectDialogField;